import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getCustomers, changeCustomerStatus } from "../../../actions/customers";

import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import VirtualizedTable from "../../../components/common/virtualized-table";
import _ from "lodash";
import { List } from "immutable";

class CustomersPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            customersFilter: ''
        };
    }

    componentDidMount() {
      this.props.getCustomers({
          projection: 'customer_code basic_info.fiscal_name basic_info.name basic_info.email basic_info.phone basic_info.mobile_phone basic_info.fiscal_id status'
      });
    };

    render() {
        const { customers, history } = this.props;
        const { customersFilter } = this.state;

        // Customers Table
        let tableData = customers;
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            customer_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'customer_code' ],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/clientes/' + value[0] }>{ value[1] }</Link>
                }
            },
            fiscal_name: {
                title: "Nombre fiscal",
                columnType: 'function',
                dataField: ['_id', 'basic_info.fiscal_name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/clientes/' + value[0] }>{ value[1] }</Link>
                }
            },
            comercial_name: {
                title: "Nombre comercial",
                columnType: 'text',
                dataField: 'basic_info.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            email: {
                title: "Email",
                columnType: 'text',
                dataField: 'basic_info.email',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            phone: {
                title: "Teléfono",
                columnType: 'text',
                dataField: 'basic_info.phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            mobile_phone: {
                title: "Móvil",
                columnType: 'text',
                dataField: 'basic_info.mobile_phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            fiscal_id: {
                title: "CIF/NIF",
                columnType: 'text',
                dataField: 'basic_info.fiscal_id',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => history.push('/ventas/clientes/' + value[0])}/>
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeCustomerStatus(value[0], 'inactive') } icon="eye-off" text="Desactivar"/>
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeCustomerStatus(value[0], 'active') } icon="eye-open" text="Activar"/>
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Filters Zone
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ customers.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ customersFilter: '' }) } ><strong>Clientes</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ customers.count(customer => customer.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ customers.count(customer => customer.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'inactive' }) } >Inactivos</span>
                </div>
            </div>
        );
        switch (customersFilter) {
            case 'active':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ customers.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: '' }) } >Clientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ customers.count(customer => customer.get('status') === 'active') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'active' }) } ><strong>Activos</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ customers.count(customer => customer.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                    </div>
                );
                tableData = customers.filter( customer => customer.get('status') === 'active' );
                break;
            case 'inactive':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ customers.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: '' }) } >Clientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ customers.count(customer => customer.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ customers.count(customer => customer.get('status') === 'inactive') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ customersFilter: 'inactive' }) } ><strong>Inactivos</strong></span>
                        </div>
                    </div>
                );
                tableData = customers.filter( customer => customer.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Clientes</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => history.push('/ventas/clientes/nuevo') } > <Icon icon="insert"/>Cliente</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const customersReducer = state.customers;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);

    return {
        customers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        changeCustomerStatus: (customerId, status) => dispatch(changeCustomerStatus(customerId, status))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersPage);


// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomersPage.js